import React, { useState } from "react";

// reactstrap components
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface Props {
  bgColor: "primary" | "blue" | "green";
  handleBgClick: (color: "primary" | "blue" | "green") => any;
}
export const FixedPlugin: React.FC<Props> = ({ bgColor, handleBgClick }) => {
  const [classes, setClasses] = useState("dropdown show-dropdown");

  const handleClick = () => {
    if (classes === "dropdown show-dropdown") {
      setClasses("dropdown show-dropdown show");
    } else {
      setClasses("dropdown show-dropdown");
    }
  };

  const activateMode = (mode: string) => {
    switch (mode) {
      case "light":
        document.body.classList.add("white-content");
        break;
      default:
        document.body.classList.remove("white-content");
        break;
    }
  };

  return (
    <div className="fixed-plugin">
      <div className={classes}>
        <div onClick={handleClick}>
          {/*<i className="fa fa-cog fa-2x">*/}
          <FontAwesomeIcon icon={"cog"} style={{ fontSize: "3em" }} />
          {/*</i>*/}
        </div>
        <ul className="dropdown-menu show">
          <li className="header-title">Observer mode:</li>
          {/*<li className="adjustments-line">*/}
          {/*  <div className="badge-colors text-center">*/}
          {/*      <span*/}
          {/*        className={*/}
          {/*          bgColor === "primary"*/}
          {/*            ? "badge filter badge-primary active"*/}
          {/*            : "badge filter badge-primary"*/}
          {/*        }*/}
          {/*        data-color="primary"*/}
          {/*        onClick={() => {*/}
          {/*          handleBgClick("primary");*/}
          {/*        }}*/}
          {/*      />{" "}*/}
          {/*    <span*/}
          {/*      className={*/}
          {/*        bgColor === "blue"*/}
          {/*          ? "badge filter badge-info active"*/}
          {/*          : "badge filter badge-info"*/}
          {/*      }*/}
          {/*      data-color="blue"*/}
          {/*      onClick={() => {*/}
          {/*        handleBgClick("blue");*/}
          {/*      }}*/}
          {/*    />{" "}*/}
          {/*    <span*/}
          {/*      className={*/}
          {/*        bgColor === "green"*/}
          {/*          ? "badge filter badge-success active"*/}
          {/*          : "badge filter badge-success"*/}
          {/*      }*/}
          {/*      data-color="green"*/}
          {/*      onClick={() => {*/}
          {/*        handleBgClick("green");*/}
          {/*      }}*/}
          {/*    />{" "}*/}
          {/*  </div>*/}
          {/*</li>*/}
          <li className="adjustments-line text-center color-change">
            <span className="color-label">LIGHT MODE</span>{" "}
            <span
              className="badge light-badge mr-2"
              onClick={() => activateMode("light")}
            />{" "}
            <span
              className="badge dark-badge ml-2"
              onClick={() => activateMode("dark")}
            />{" "}
            <span className="color-label">DARK MODE</span>{" "}
          </li>
          <li />
        </ul>
      </div>
    </div>
  );
};
